import { memoize } from '@/lib/memoize';
import type { State, Tag } from './types';

export type Mutation = { type: 'setTags'; data: Tag[] };

export function reducer(state: State, action: Mutation) {
  switch (action.type) {
    case 'setTags':
      return setTags(state, action);
    default:
      return state;
  }
}

function setTags(_state: State, { data }: { data: Tag[] }) {
  return {
    list: data,
    lookup: memoize(data, 'id'),
    loaded: true,
  };
}
